import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const booleanComparisonUiNodeSpec: NodeSpec<NodeCfg<'booleanComparison'>> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'input1', 'input2' ],
    }),
    cfg: () => ({ controlValues: { operation: 'AND' }, id: getUID(), kind: 'booleanComparison', disabled: false, width: 220 }),
    controls: nodeCfg => ({
        operation: defineControlOpts({
            cfg: {
                items: [
                    { label: 'AND', value: 'AND' },
                    { label: 'OR', value: 'OR' },
                    { label: 'XOR', value: 'XOR' },
                ],
                kind: 'selection',
                label: 'Operation',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.operation,
        }),
    }),
    inputs: () => ({
        input1: {
            socket: 'boolean',
            label: 'Input 1',
        },
        input2: {
            socket: 'boolean',
            label: 'Input 2',
        },
    }),
    kindLabel: 'Boolean Comparison',
    nodeCategory: 'boolean',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
